import * as React from "react";
import Spin from "antd/es/spin";
import QRCode from "antd/es/qr-code";
import Result from "antd/es/result";
import Link from "antd/es/typography/Link";
import Flex from "antd/es/flex";
import notification from "antd/es/notification";
import Text from "antd/es/typography/Text";
import Button from "antd/es/button";
import { useShortUrl } from "../api";
import { Chains } from "./types";

export interface ShortUrlProps {
    url: string;
    type: Chains;
    isQR?: boolean;
}

export const ShortUrl: React.FunctionComponent<ShortUrlProps> = (props) => {
    const urlLoader = useShortUrl(props.url);
    const [notify, render] = notification.useNotification();

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(urlLoader.data || props.url);
            notify.success({
                message: "Link Copied",
                description: "Paste it in your preferred wallet browser to proceed with payment.",
            });
        } catch (err) {
            console.error(err);
            notify.error({
                message: "Copy Failed",
                description: "Unable to copy the link to clipboard.",
            });
        }
    };

    if (urlLoader.isLoading) {
        return <Spin />;
    }

    if (urlLoader.isError) {
        return (
            <Result
                title="Failed to generate short link"
                status="error"
                subTitle={(
                    <Link href={props.url}>
                        Pay now or open in an appropriate browser
                    </Link>
                )}
            />
        );
    }

    if (urlLoader.data) {
        return props.isQR ? (
            <QRCode
                errorLevel="H"
                value={`${urlLoader.data}?type=${props.type}`}
                icon={(() => {
                    switch (props.type) {
                        case "Ethereum":
                            return require("../metamask.png");
                        case "Liberland":
                            return require("../logo-small.png");
                        case "Tron":
                            return require("../tron.png");
                        case "Solana":
                            return require("../solana.png");
                    }
                })()}
                size={300}
            />
        ) : (
            <Flex className="LinkDescriptor" vertical align="center" justify="center" gap="15px">
                {render}
                <div>
                    <Text strong>Don't have your wallet on this device?</Text>
                </div>
                Open the payment link from a dApp browser instead:
                <Button
                    onClick={handleCopy}
                >
                    Copy Wallet Link
                </Button>
            </Flex>
        );
    }

    return null;
};
